// frontend/src/native/appVersion.ts
//
// EINZIGE QUELLE DER WAHRHEIT für die Web-Bundle-Version, die der Client meldet.
//
// Diese Konstante ist die "bundle"-Version, die der OTA-Client an den Server
// schickt (`/api/ota/check?bundle=...`) und die DiagnosticsOverlay anzeigt. Sie
// muss bei jedem Web-Bundle-Release gemeinsam mit `version.js` /
// `npm run version:sync` hochgezogen werden (der Orchestrator übernimmt den
// Bump). Vorher wurde die Version nur inline in DiagnosticsOverlay.tsx als
// '0.1.0' gepflegt — das war eine zweite, falsche Wahrheit. Ab jetzt importieren
// sowohl ota.ts als auch DiagnosticsOverlay.tsx diese eine Konstante.
//
// WICHTIG für OTA: Wenn ein OTA-Bundle ausgeliefert wird, enthält dessen JS
// diese Konstante mit der NEUEN Version. Genau diese Version meldet der Client
// dann beim nächsten `check` zurück, sodass der Server denselben Stand nicht ein
// zweites Mal anbietet (Server vergleicht `bundle !== version`).
export const APP_VERSION = '7.4.6.1';
